export const Tabs = () => import('./Tabs')
export const ContactMethodsTableDisplay = () => import('./ContactMethodsTableDisplay')
export const ContactMethodsTooltip = () => import('./ContactMethodsTooltip')
export const ContactOverlayPaneTabs = () => import('./ContactOverlayPaneTabs')
export const ContactForm = () => import('./ContactForm')
export const ContactView = () => import('./ContactView')
export const ContactMethodsForm = () => import('./ContactMethodsForm')
export const ContactMethodsDisplay = () => import('./ContactMethodsDisplay')
export const ContactNotes = () => import('./ContactNotes')
